import React from 'react'
import './WebCardBottomSection.css'
import { Link } from "react-router-dom";
import logofooter from "../../../images/new_logo.png";
import fadedbg from "../../../images/fade-footer-img.svg";

const WebCardBottomSection = () => {
    return (
        <div>
            <section className="seven pt-0 z-0">
                <div className="container text-center">
                    <div className="footer-content">
                        <div className="logo">
                            <Link to="/">
                                <img src={logofooter} alt="logo" />
                            </Link>
                        </div>
                        <div className='terms-conditions mt-0'>
                            <div className='list-text'><Link to="/terms-of-service">Terms of Service</Link></div>
                            <div className='vertical-line'></div>
                            <div className='list-text'><Link to="/privacy-policy">Privacy Policy</Link></div>
                        </div>
                    </div>
                </div>
                <div className="fade-bg">
                    <img src={fadedbg} alt="Footer-background"></img>
                </div>
                <div className="fade-bg-right">
                    <img src={fadedbg} alt="Footer-background"></img>
                </div>
            </section>
        </div>
    )
}

export default WebCardBottomSection